import {
  IMPORTING_BATCH_ADJUSTMENTS,
  IMPORTING_BATCH_ADJUSTMENTS_SUCCESS,
  IMPORTING_BATCH_ADJUSTMENTS_FAILURE,
  UPLOAD_BATCH_ADJUSTMENTS,
  UPLOAD_BATCH_ADJUSTMENTS_SUCCESS,
  UPLOAD_BATCH_ADJUSTMENTS_FAILURE,
  RESET_UPLOADED_BATCH_ADJUSTMENTS,
} from './types';
import {
  importBatchAdjustments as importBatchAdjustmentsApi,
  validateBatchAdjustments as validateBatchAdjustmentsApi,
} from '../api';
import { normalizeCellToNullableNumber, normalizeCellToString } from '../../../utils/readXlsxFile.utils';
import readXlsxFileAsJson from '../../../shared/xlsxImport/readXlsxFileAsJson';
import excelFileTypeValidator from '../../../shared/xlsxImport/validators/excelFileType.validator';
import columnHeadersValidator from '../../../shared/xlsxImport/validators/columnHeaders.validator';
import noEmptyRowsValidator from '../../../shared/xlsxImport/validators/noEmptyRows.validator';
import calculateImportRangeFactory from '../../../shared/xlsxImport/calculateImportRangeFactory';
import emptyRowsTrimmer from '../../../shared/xlsxImport/processors/emptyRowsTrimmer.processor';

import fixDataTypes from '../xlsxImport/processors/fixDataTypes.processor';
import truncateDescription from '../xlsxImport/processors/truncateDescriptions.processor';
import { FIELD_MAPPINGS, IMPORT_RANGE_LAST_COLUMN } from '../xlsxImport/constants';
import columnHeaders from '../columnHeaders';

import { showAlert } from '../../../shared/store/actions';
import alertTypes from '../../../shared/alertTypes';

import { errorNotification, infoNotification, successNotification } from '../../../shared/store/notificationActions';

const VALIDATION_FAILED_MESSAGE = 'Failed to fetch';
const ROWS_LIMIT = 1000;

export const resetUploadedBatchAdjustments = () => async dispatch =>
  dispatch({ type: RESET_UPLOADED_BATCH_ADJUSTMENTS });

export const uploadBatchAdjustments = (file, periodName) => async dispatch => {
  dispatch({
    type: UPLOAD_BATCH_ADJUSTMENTS,
  });
  dispatch(infoNotification('Batch Adjustments Upload Processing...'));
  try {
    const batchAdjustments = await readXlsxFileAsJson({
      file,
      fieldMappings: FIELD_MAPPINGS,
      preprocessors: [emptyRowsTrimmer, fixDataTypes, truncateDescription],
      fileValidators: [excelFileTypeValidator],
      prevalidators: [columnHeadersValidator],
      postvalidators: [noEmptyRowsValidator],
      fieldNormalizers: {
        companycode: normalizeCellToString,
        amount: normalizeCellToNullableNumber,
        multiplier: normalizeCellToNullableNumber,
      },
      validationData: {
        columnHeaders,
      },
      mapToJsonOptions: {
        header: columnHeaders,
      },
      getRange: calculateImportRangeFactory(IMPORT_RANGE_LAST_COLUMN),
    });

    if (batchAdjustments.length > ROWS_LIMIT) {
      dispatch(errorNotification(`The number of rows exceeded ${ROWS_LIMIT}`));
      dispatch({
        type: UPLOAD_BATCH_ADJUSTMENTS_FAILURE,
      });
      dispatch(resetUploadedBatchAdjustments());
      return;
    }

    const validationErrors = await validateBatchAdjustmentsApi(batchAdjustments, periodName);
    if (validationErrors) {
      Object.keys(validationErrors).forEach(errorIndex => {
        batchAdjustments[errorIndex].validationData = validationErrors[errorIndex];
      });
    }

    dispatch({
      type: UPLOAD_BATCH_ADJUSTMENTS_SUCCESS,
      batchAdjustments,
    });
  } catch (error) {
    if (error.message === VALIDATION_FAILED_MESSAGE) {
      dispatch(errorNotification(error.message));
    } else {
      dispatch(showAlert(error.message, alertTypes.DANGER));
    }
    dispatch({
      type: UPLOAD_BATCH_ADJUSTMENTS_FAILURE,
    });
  }
};

export const importBatchAdjustments = (batchAdjustments, periodName) => async dispatch => {
  dispatch({
    type: IMPORTING_BATCH_ADJUSTMENTS,
  });
  try {
    await importBatchAdjustmentsApi(batchAdjustments, periodName);
    dispatch({
      type: IMPORTING_BATCH_ADJUSTMENTS_SUCCESS,
    });
    dispatch(successNotification(`${batchAdjustments.length} adjustments saved`));
  } catch (error) {
    dispatch(errorNotification(error.message));
    dispatch({
      type: IMPORTING_BATCH_ADJUSTMENTS_FAILURE,
    });
  }
};
